import Logo from "@/interface/components/design-system/logo/logo";
import { Container } from "@/interface/components/layout/container";
import { MainContainer } from "@/interface/components/layout/main-container";

export default function PageLoader() {
  return (
    <MainContainer>
      <Container>
        <div className="relative flex h-full w-full flex-auto flex-col gap-10 p-5">
          <div className="absolute left-1/2 top-1/2 h-24 w-24 -translate-x-1/2 -translate-y-1/2 animate-pulse flex-col items-center justify-center rounded-full border border-nt-secondary/40 bg-nt-secondary-500/60" />
          <Logo className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 select-none bg-white" />
          <p className="absolute left-1/2 top-[calc(50%+4rem)] w-full -translate-x-1/2 -translate-y-1/2 select-none text-center font-poppins text-nt-secondary-500">
            Cargando...
          </p>
        </div>
      </Container>
    </MainContainer>
  );
}
